export default {
  help: {
    zh: '帮助',
    en: 'Help',
  },
  about: {
    zh: '关于',
    en: 'About',
  },
  kuiperDesc: {
    zh: 'LF Edge eKuiper 是 Golang 实现的轻量级物联网边缘分析、流式处理开源软件，可以运行在各类资源受限的边缘设备上。eKuiper 设计的一个主要目标就是将在云端运行的实时流式计算框架（比如 Apache Spark，Apache Storm 和 Apache Flink 等）迁移到边缘端。eKuiper 参考了上述云端流式处理项目的架构与实现，结合边缘流式数据处理的特点，采用了编写基于源 (Source)，SQL (业务逻辑处理), 目标 (Sink) 的规则引擎来实现边缘端的流式数据处理。',
    en: 'LF Edge eKuiper is an edge lightweight IoT data analytics / streaming software implemented by Golang, and it can be run at all kinds of resource constrained edge devices. One goal of eKuiper is to migrate the cloud streaming software frameworks (such as Apache Spark，Apache Storm and Apache Flink) to edge side. eKuiper references these cloud streaming frameworks, and also considered special requirement of edge analytics, and introduced rule engine, which is based on Source, SQL (business logic) and Sink, rule engine is used for developing streaming applications at edge side.',
  },
  docs: {
    zh: '使用文档',
    en: 'Documentation',
  },
  docsDesc: {
    zh: '我们为您准备了齐全的使用文档，帮助您熟悉更多强大的功能。',
    en: 'We have prepared a comprehensive documentation to help you familiarize yourself with more powerful features.',
  },
  forwardView: {
    zh: '前往查看',
    en: 'View documentation',
  },
}
